import { rankWith, and, uiTypeIs, schemaMatches } from '@jsonforms/core';
import { withJsonFormsEnumProps } from '@jsonforms/react';
import SelectToothShadeDialogControl from '../../components/selectToothShadeDialogControl';
import isEmpty from 'lodash/isEmpty';

const isSelectToothShadeDialogControl = and(
  uiTypeIs('Control'),
  schemaMatches(
    (schema) => !isEmpty(schema) && schema.format === 'selectToothShadeDialog'
  )
);

const customSelectToothShadeDialogControlTester = rankWith(
  4,
  isSelectToothShadeDialogControl
);

export default {
  tester: customSelectToothShadeDialogControlTester,
  renderer: withJsonFormsEnumProps(SelectToothShadeDialogControl),
};
